module.exports = __webpack_public_path__ + "static/img/working-hour.6b8ec2af.svg";